import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import * as serviceWorker from './serviceWorker';

import initReactFastclick from 'react-fastclick';

initReactFastclick();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

if (window.cordova) {
    document.addEventListener("deviceready", onDeviceReady, false);
} else {
    launch();
}

function onDeviceReady()
{
    document.addEventListener("backbutton", onBackKeyDown, false);
    launch();
}

function onBackKeyDown(e)
{
    e.preventDefault();
}

function launch()
{
    ReactDOM.render(<App />, document.getElementById('root'));
}